import useToast from "hooks/useToast";
import "./MyPastTrips.scss";
import {
  LegalFooter,
  MDetailRoute,
  PstInvoices,
  // MyTicketsQr,
  StartTraveling,
  SummaryAmounts,
  AccessToApp,
  UiIcon,
  UiModal,
  UiPaginator,
  AveTickets,
  CercaniasTickets,
  CancelPstAsk,
  CancelPstError,
  MTmbDetailActivity,
  MGlobickDetailActivity,
  MSixtDetailActivity,
  InfoPostPayment,
  UiNewPaginator,
} from "libs/raas-ui-react-components/src/components";
import /* React, */ { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { IData, IDeletePstBody, IMyTripsResponse } from "../MyTrips/MyTrips.model";
import { calcCurrentPrice, getDetailActivityFromBooking, getDetailExperienceFromBooking, getDetailRentingFromBooking, getPaymentInfoData, getTripCardComponentData, getTripDetailRouteComponentData, getTripListCall } from "../MyTrips/MyTrips.service";
import {
  CallFailedPageLiterals,
  choiceAllOption,
  desgloseModalLiterals,
  getFooterLiterals,
  getInitialCancelModalLiterals,
  getLiteralesErrorInvocesModalError1,
  getLiteralesErrorInvocesModalError2,
  initialAveTicketsLiterals,
  initialDetailLiterals,
  initialDetailLiteralsAtom,
  initialDetailLiteralsMyTrips,
  initialDetailTMBLiterals,
  initialGeneralLiterals,
  initialInvoiceModalLiterals,
  initialTicketsModalLiterals,
  // invoiceModalButtonLiterals,
  mock,
  NoTripsPageLiterals,
  outwardJourneyOption,
  summaryTotalMock,
  tripSummaryMock,
} from "./MyPastTrips.util";
import { useNavigate } from "react-router-dom";
import useSession from "hooks/useSession";
import { ItemType, SummaryType } from "./MyPastTrips.model";
import { initialPastTrips } from './MyPastTrips.util';
import { base64toBlob, downloadBlob, getCardsInvoiceModal, getFilterInvoiceModal, InvoicesCall, openConditionsLink, prepareDataForTickets, prepareAvePassengersForModal, TicketsCall, transformTicket, prepareCercaniasPassengersForModal } from "./MyPastTrips.service";
import { downloadAveBlob } from "components/DescargadorPKPass/PKpass";
import { NoSessionPageLiterals } from "./MyPastTrips.literals";
import { deletePSTCall } from "../MyTrips/functions/manageDelete";
import { detailTags, travelsType } from "../MyTrips/MyTrips.util";
import { IDetailActivity } from "models/TripInterface";
import { getTokenGlobick, globickMMB } from "services/util/globick-service";
import { DontBuyLiterals, getProvisionCardLiterals, sixtDetail } from "../MyTrips/MyTrips.literals";

export const MyPastTrips = () => {
  const [t] = useTranslation("myPastTrips"); // crear el fichero de traduciones
  const [t2] = useTranslation("myTrips"); // crear el fichero de traduciones
  const [t4] = useTranslation("tmbPages");
  const [t6] = useTranslation('aveFlow')

  const footerLiterals = getFooterLiterals(t);

  const { openToast } = useToast();
  const navigate = useNavigate();
  const { logged, tokenGlobick, setTokenGlobick } = useSession();

  const [detailsSelector, setDetailSelector] = useState(
    mock.detailData as any[]
  );
  const [detailLiteralsAtom, setDetailLiteralsAtom] = useState(
    initialDetailLiteralsAtom(t)
  );
  const [detailLiterals, setDetailLiterals] = useState(initialDetailLiterals(t));
  const [detailTMBLiterals, setDetailTMBLiterals] = useState(initialDetailTMBLiterals(t));
  const [mytripsliterals, setmytripsliterals] = useState(initialDetailLiteralsMyTrips(t2) as any);
  const [detailPrice, setDetailPrice] = useState(
    {} as { sum: number; desc: string }
  );

  const [generalLiterals, setGeneralLiterals] = useState(initialGeneralLiterals(t));
  const [myTripsData, setMyPastTripsData] = useState({} as any);
  const [filteredPastTrips, setFilteredPastTrips] = useState(initialPastTrips(t))

  const [paginatorData, setPaginatorData] = useState([] as any); // UiPaginador
  const [indexCardSelected, setIndexCardSelected] = useState(0); // Posición de la carta seleccionada
  const [tripSummaryData, setTripSummary] = useState(tripSummaryMock as any); // Detalle del viaje - Resumen y Pago
  const [tripTotal, setTripTotal] = useState({} as any); // Modal - Ver desglose
  let [fromToData, setFromToData] = useState({} as any) // para tener info de ida y vuelta


  //Modal
  const [showSummaryTotal, setShowSummaryTotal] = useState(false);

  //Invoice Modal
  const [invoiceModalLiterals, setInvoiceModalLiterals] = useState(initialInvoiceModalLiterals(t));
  const [showInvoiceModal, setShowInvoiceModal] = useState(false)
  const [filterTagInvoiceModal, setFilterTagInvoiceModal] = useState([] as any);
  const [cardsInvoiceModal, setCardsInvoiceModal] = useState([] as any);
  let [showRequestInvoiceButton, setShowRequestInvoiceButton] = useState(true);

  //Cercanias Tickets Modal PROVISIONAL
  const [ticketsModalLiterals, setTicketsModalLiterals] = useState(initialTicketsModalLiterals(t));
  const [showTicketsModal, setShowTicketsModal] = useState(false);
  const [showCancelTicketModal, setShowCancelTicketModal] = useState(false) //Cancelar trayecto
  let [cercaniasPassengers, setCercaniasPassengers] = useState([]);
  let [tickets, setTickets] = useState([]);

  ///////////////// MODALES DE ELIMINAR TRAYECTO /////////////////
  /* Error al eliminar pst */
  const [showErrorCancelPst, setShowErrorCancelPst] = useState(false); // Eliminar ultimo transbordo.
  const [showAlreadyCancelledPst, setShowAlreadyCancelledPst] = useState(false); // Ya ha sido cancelado.

  const [PSTPassengerToDelete, setPSTPassengerToDelete] = useState({} as any);
  const [pstToDeleteData, setPstToDeleteData] = useState(undefined as any);
  const [showCercaniasTicketCancel, setShowCercaniasTicketCancel] = useState(false); // Eliminar billete de AVE (1 por 1)

  //Ave tickets Modal PROVISIONAL
  const [aveTicketsModalLiterals, setAveTicketsModalLiterals] = useState(initialAveTicketsLiterals(t));
  const [showAveTicketsModal, setShowAveTicketsModal] = useState(false);
  const [summaryLocal, setSummary] = useState(null as any);
  let [avePassengers, setAvePassengers] = useState([]);
  //let [purchaseType, setPurchaseType] = useState('');
  let [purchaseType, setPurchaseType] = useState(null);
  let [passBook, setPassBook] = useState([]);
  //Body para los tickets
  let [booking, setBooking] = useState({});
  const [detailActivitySelected, setDetailActivitySelected] = useState<any>();
  const [detailExperienceSelected, setDetailExperienceSelected] = useState<any>()
  const [detailSixtSelected, setDetailSixtSelected] = useState<any>()
  const [dataCodePromo, setDataCodePromo] = useState({ voucherAmount: 0 as any });

  const [showBoltModal, setShowBoltModal] = useState(false);
  const checkBoltModalLiterals = getProvisionCardLiterals(t2);

  let [idLeg, setIdLeg] = useState(null as any);
  let [tab, setTab] = useState({ code: 'tab1' });
  let lenguage = "";

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [showErrorInvocesModal, setShowErrorInvocesModal] = useState(false) //Modal error de facturas
  const [literalesErrorInvocesModal, setLiteralesErrorInvocesModal] = useState(null as any) //Modal error de facturas

  //Si cambia de idioma relanzar logica para que capte el nuevo literal
  useEffect(() => {
    if (sessionStorage.getItem('raas-language') != lenguage) {
      lenguage = sessionStorage.getItem('raas-language') as any
      setDetailLiterals(initialDetailLiterals(t));
      setDetailTMBLiterals(initialDetailTMBLiterals(t))
      setDetailLiteralsAtom(initialDetailLiteralsAtom(t));
      setGeneralLiterals(initialGeneralLiterals(t));
      setFilteredPastTrips(initialPastTrips(t));
      setInvoiceModalLiterals(initialInvoiceModalLiterals(t))
      setTicketsModalLiterals(initialTicketsModalLiterals(t));
      setAveTicketsModalLiterals(initialAveTicketsLiterals(t));
      setTripSummary({
        ...summaryLocal,
        literals: {
          reservationdate: t('desgloseModalLiterals.reservationdate'),
          paymethod: t('desgloseModalLiterals.paymethod'),
          summaryprice: t('desgloseModalLiterals.summaryprice'),
          totalticket: t('desgloseModalLiterals.totalticket'),
          cancelationfee: t('desgloseModalLiterals.cancelationfee'),
          discounts: t('desgloseModalLiterals.discounts'),
          paid: t('desgloseModalLiterals.paid'),
          pendingpay: t('desgloseModalLiterals.pendingpay'),
          totalamount: t('desgloseModalLiterals.totalamount'),
          approx: t('desgloseModalLiterals.approx'),
          breakdown: t('desgloseModalLiterals.breakdown'),
          requestInvoiceText: t('desgloseModalLiterals.requestInvoiceText'),
          cancellationRefund: t("desgloseModalLiterals.cancellationRefund"),
          discountsUNKNOWN: t("desgloseModalLiterals.discountsUNKNOWN"),
        },
      });
      if ((!!myTripsData && myTripsData?.status === 200) && !checkEmptyObject(myTripsData)) {
        selectItemCard(myTripsData.data);
        const paginadorData = getTripCardComponentData(myTripsData?.data, true, t);
        const mappedPaginadorData = paginadorData.map(item => item?.outwardJourney);

        setPaginatorData(mappedPaginadorData);
      }
    }

  }, [t]);


  useEffect(() => {
    //setTodayTrip(undefined);
    _getTripList();
  }, [])

  useEffect(() => {

    selectItemCard(myTripsData.data, 0);
  }, [paginatorData]);


  useEffect(() => {
    if ((!!myTripsData && myTripsData?.status === 200) && !checkEmptyObject(myTripsData)) {
      selectItemCard(myTripsData.data, 0);
    }
  }, [myTripsData]);

  const _getTripList = () => {
    getTripListCall(
      "PAST",
      "1",
      (response: IMyTripsResponse) => {


        //const personasOrdenadasPorEdad = response.data.bookings.sort((a, b) => b.id - a.id);
        //response.data.bookings.sort((a, b) => new Date(a.outwardJourney.originDate).getTime() - new Date(b.outwardJourney.originDate).getTime());
        setCurrentPage(response.data.pageable.pageNumber)
        setTotalPages(response.data.pageable.totalPages)


        setMyPastTripsData(response); // Respuesta real.
        const paginadorData = getTripCardComponentData(response?.data, true, t);

        const mappedPaginadorData = paginadorData.map(item => item?.outwardJourney);

        setPaginatorData(mappedPaginadorData);

      },
      (err: any) => {
        setMyPastTripsData(err);

      }
      , "DESC", window.sessionStorage["raas-trip-mock"]);
  };

  const handleBack = () => {
    navigate('/my-trips');
  }

  const handleButtonClick = (ev: CustomEvent) => {
    switch (ev.detail) {
      case "start":
        navigate("/plan");
        break;
      case "login":
        navigate("/login");
        break;
      case "create":
        navigate("/register-user");
        break;
      case "retry":
        navigate(0);
        break;
      default:
        break;
    }
  };

  const handleCardPaginatorSelected = (ev: CustomEvent) => {
    setTab({ code: 'tab1' })
    selectItemCard(myTripsData.data, ev.detail.index);
    setIndexCardSelected(ev.detail.index);
  }

  const handlePagePaginatorSelected = (ev: CustomEvent) => {
    getTripListCall(
      "PAST",
      ev.detail.index,
      (response: IMyTripsResponse) => {
        //response.data.bookings.sort((a, b) => new Date(a.outwardJourney.originDate).getTime() - new Date(b.outwardJourney.originDate).getTime());
        setMyPastTripsData(response); // Respuesta real.
        const paginadorData = getTripCardComponentData(response?.data, true, t);

        const mappedPaginadorData = paginadorData.map(item => item?.outwardJourney);

        setPaginatorData(mappedPaginadorData);

      },
      (err: any) => {
        setMyPastTripsData(err);
      }
      , "DESC", window.sessionStorage["raas-trip-mock"]);
  }




  const selectItemCard = (data: IData, selectedIndex: number = 0, triptype: 'outward' | 'return' = 'outward') => {

    if (paginatorData[selectedIndex] != undefined) {
      if (data?.bookings[selectedIndex]?.outwardJourney?.experience) {

        setPurchaseType(paginatorData[selectedIndex].purchaseType)
        const detailExperience = getDetailExperienceFromBooking(data?.bookings[selectedIndex], t, 'myPastTrips');
        setDetailExperienceSelected(detailExperience);
      } else if (/*Object.entries(data?.bookings[selectedIndex]?.outwardJourney?.trip).length !== 0*/ data?.bookings[selectedIndex]?.outwardJourney?.trip) {

        const detailSelectorData = getTripDetailRouteComponentData(data?.bookings[selectedIndex], t, true, t6);
        setPurchaseType(paginatorData[selectedIndex].purchaseType)
        const trip = triptype === 'outward' ? 'outwardJourney' : 'returnJourney';
        //const mappedDetailData = detailSelectorData[selectedIndex]?.[trip];
        const mappedDetailData = detailSelectorData[0][trip];
        fromToData = detailSelectorData[0];

        const outwardJourney = detailSelectorData[0]?.outwardJourney;
        const returnJourney = detailSelectorData[0]?.returnJourney;
        const isReturnTrip = !!outwardJourney && !!returnJourney;

        const initialDetailLiteralsMapped = {
          ...initialDetailLiterals(t),
          choice: isReturnTrip ? choiceAllOption(t) : outwardJourneyOption(t),
        };
        setDetailLiterals(initialDetailLiteralsMapped);
        setDetailSelector(mappedDetailData); // Detalle del viaje

        setDetailPrice(calcCurrentPrice(mappedDetailData)); // Detalle de pagos
        //Prepare invoice modal to show
        renderInvoiceModalFilter(data?.bookings[selectedIndex] as any, selectedIndex, purchaseType);

        renderInvoiceModalCards(data?.bookings[selectedIndex] as any, selectedIndex);

        let showButton = false;
        mappedDetailData.forEach((t: any) => {
          if (t.cancelled == true) {
            setShowRequestInvoiceButton(false)
            showButton = false
          } else {
            setShowRequestInvoiceButton(true)
            showButton = true
          }
        });

        renderResumePayment(data?.bookings[selectedIndex] as any, selectedIndex, calcCurrentPrice(outwardJourney), outwardJourney, showButton);

      } else if (data?.bookings[selectedIndex]?.outwardJourney?.activity) {
        setPurchaseType(paginatorData[selectedIndex].purchaseType)
        const detailActivity = getDetailActivityFromBooking(data?.bookings[selectedIndex], t, t4, "myPastTrips");
        setDetailActivitySelected(detailActivity);

      } else if (data?.bookings[selectedIndex]?.outwardJourney?.renting) {
        setPurchaseType(paginatorData[selectedIndex].purchaseType)
        const detailSixt = getDetailRentingFromBooking(data?.bookings[selectedIndex], t);
        setDetailSixtSelected(detailSixt);
      }

    }
  }

  const handleChangeTripInfo = (ev: CustomEvent) => {
    if (ev.detail?.code === 'returnJourney') {
      selectItemCard(myTripsData.data, indexCardSelected, 'return');
    }
    else if (ev.detail?.code === 'outwardJourney') {
      selectItemCard(myTripsData.data, indexCardSelected, 'outward');
    }
  }

  const renderInvoiceModalFilter = (data: IData, selectedIndex: number = 0, purchaseType: any) => {

    const selectedData = getTripDetailRouteComponentData(data, t, true, t6);
    const cardPhases = selectedData[0]?.outwardJourney;
    const filter = getFilterInvoiceModal(cardPhases);


    //Mostrar el boton de invoices si hay invoices
    if (purchaseType === travelsType.TRIP && cardPhases.length != 0) {


      if (cardPhases[0].cancelled == true) {
        showRequestInvoiceButton = false;
        setShowRequestInvoiceButton(false);
      } else {
        if (filter.length == 0) {
          showRequestInvoiceButton = false;
          setShowRequestInvoiceButton(false);
        }
        else {
          showRequestInvoiceButton = true;
          setShowRequestInvoiceButton(true);
        }
      }
    }



    setFilterTagInvoiceModal(getFilterInvoiceModal(cardPhases))

  }

  const renderInvoiceModalCards = (data: IData, selectedIndex: number = 0) => {

    const selectedData = getTripDetailRouteComponentData(data, t, true, t6);
    const cardInfo = selectedData[0];

    const finalCards = getCardsInvoiceModal(cardInfo, t);
    setCardsInvoiceModal(finalCards.result);

  }

  const getInvoiceData = (data: any,) => {
    const provider = data.provider
    const idBook = data.bookings[0]?.idBook
    let originDate = "", destinationDate = "";
    if (provider === 'freenow') {
      originDate = detailsSelector[0].trip.Origin.date + "T" + detailsSelector[0].departureTime
      destinationDate = detailsSelector[0].trip.Destination.date + "T" + detailsSelector[0].arrivalTime
    } else {
      originDate = detailsSelector[0].trip.Origin.date
      destinationDate = detailsSelector[0].trip.Destination.date
    }

    const referenceId = data.bookings[0]?.referenceId

    InvoicesCall(idBook, originDate, destinationDate, referenceId, (response: any) => {

      if (response?.data?.invoiceUrl) {
        //Abrimos navegador o descarga automatica
        window.open(response?.data?.invoiceUrl, '_blank');
      } else if (response?.data?.invoice && provider === 'movitaxi') {
        openToast("error", t('desgloseModalLiterals.requestFailed'), t('initialInvoiceModalLiterals.literals.warningMoviTaxi24h'))

      }
      else if (response?.data?.invoice && provider !== 'cooltra') {
        //Convertimos el pdf en blob
        const responseBlobed = base64toBlob(response.data.invoice);
        downloadBlob(responseBlobed, "Invoice");

      } else if ((response?.data?.invoiceUrl && response?.data?.invoice) && provider === 'cooltra') {
        openToast("error", t('desgloseModalLiterals.requestFailed'), t('initialInvoiceModalLiterals.literals.warningCooltraFactura'))
      }
      else {
        //Si no viene nada muestro mensaje de error
        openToast("error", t('desgloseModalLiterals.requestFailed'), t('desgloseModalLiterals.requestFailed'))
      }


    }, (err: any) => {
      const msg = err?.data?.errors[0]?.message || err?.statusText;
      const codeError = err?.data?.errors[0]?.code
      if (codeError !== null) {
        let literals
        if (codeError === "ERROR_HTTP_FINANCIAL_012" as any) {
          literals = getLiteralesErrorInvocesModalError1(t)
        } else {
          literals = getLiteralesErrorInvocesModalError2(t)
        }
        setShowInvoiceModal(false)
        setShowErrorInvocesModal(true)
        setLiteralesErrorInvocesModal(literals)
      } else {
        openToast(
          "error",
          t('desgloseModalLiterals.requestFailed'),
          `${err.status}: ${msg}`
        )
      }

    }, "false")
  }


  const getTicketData = (id: any, books: any, type: any, travellers?: any) => {
    TicketsCall(id, (response: any) => {
      if (type == "cercanias") {

        cercaniasPassengers = prepareCercaniasPassengersForModal(travellers, response.data.tickets, id)
        setCercaniasPassengers(cercaniasPassengers)
        tickets = transformTicket(response.data.tickets, cercaniasPassengers)
        setTickets(tickets)

        setShowTicketsModal(true);

      } else if (type == "ave") {
        avePassengers = prepareAvePassengersForModal(travellers, response.data.passBooks);
        setAvePassengers(avePassengers)
        setShowAveTicketsModal(true)
      }
    }, (err: any) => {
      const msg = err?.data?.errors[0]?.message || err?.statusText;
      openToast(
        "error",
        t("literals.errorRequest"),
        `${err.status}: ${msg}`
      )
    }, books)
  }

  const manageButtonFooter = (event: any) => {

    // CONTRATOS: CAMBIAR idBooks por entitlementIds
    booking = { entitlementIds: prepareDataForTickets(event.detail) };
    if (event.detail.event == "cercanias") {
      getTicketData(event.detail?.orderId?.id, booking, event.detail.event, event.detail?.orderId?.travellers)
      /* Para eliminar el billete de cercanias */
      const bookings = event?.detail?.orderId?.bookings;
      const provider = event?.detail?.orderId?.provider;
      const travellers = event?.detail?.orderId?.travellers;
      let indexTravellers: number = 0;
      const passengers = travellers?.map((item: any, idx: number) => {
        const statusBook = bookings?.find((book: any) => book.idBook == item.bookID)?.status;
        indexTravellers = bookings?.findIndex((book: any) => book.idBook == item.bookID);
        return {
          id: idx,
          fullname: `${item?.personalInformation?.customerFullName?.name} ${item?.personalInformation?.customerFullName?.firstSurname}`,
          idBook: item.bookID,
          orderId: event?.detail?.orderId?.id,
          disable: statusBook !== "BOOKED"
        }
      })
      /* Se guarda la info del pst a eliminar */
      const pstToDelete = detailsSelector.find((detail: any) => detail.idPst === event.detail.id);
      setPstToDeleteData(pstToDelete);
      setPSTPassengerToDelete({ ...passengers[indexTravellers || 0], provider });
      /* FIN Para eliminar el billete de cercanias */
    }
    else if (event.detail.event == "ave") {
      getTicketData(event.detail?.orderId?.id, booking, event.detail.event, event.detail?.orderId?.travellers)
    }
    else if (event.detail.event == "cancelTrip") {
      setShowCancelTicketModal(true)
    }
  }

  const handleAveTicketPassenger = (ev: CustomEvent) => {
    passBook = ev.detail.ticketId;
    setPassBook(passBook);

  }

  const manageButtonRedirecion = (ev: CustomEvent) => {
    switch (ev?.detail?.idbutton) {
      case "downloadInvoice":
        getInvoiceData(ev?.detail?.idcard)
        break;
      case "sendForm":
        window.open('https://raas-invoice-service-qftxvqnnza-no.a.run.app/', '_blank');
        break;
      case "accesForm":
        window.open('https://www.renfe.com/es/es/ayuda/solicitar-factura/formulario-factura', '_blank');
        break;
      default:
        break;
    }

  }
  const handleclickButtonCancelTripModal = (ev: CustomEvent) => {
    if (ev.detail) {
      switch (ev.detail) {
        case 'cancel-button':
          setPstToDeleteData(null);
          setPSTPassengerToDelete(null);
          if (showCercaniasTicketCancel) setShowCercaniasTicketCancel(false);
          break;
        case 'continue-button':
          if (PSTPassengerToDelete?.ticketId?.idBook) {
            if (showCercaniasTicketCancel || PSTPassengerToDelete?.provider === 'renfe-cercanias') {
              if (showCercaniasTicketCancel) setShowCercaniasTicketCancel(false);
              callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData?.orderId?.id, [PSTPassengerToDelete?.ticketId?.idBook]);
            }
          }
          break;
      }
    }
  }
  const callToDeletePST = (data: IDeletePstBody, orderId?: any, idBooks?: any[], isAve?: boolean) => {
    deletePSTCall({ data, orderId, idBooks },
      (response: any) => {
        if (response?.data?.journeys?.[0]?.cancelStatus === 'CANCELATION_SUCCESS') {
          // console.log('Eliminado con éxito', response);
          setTimeout(() => {
            // console.log('Refresco getBookings');
            _getTripList();
          }, 2000);
        } else if (response?.data?.journeys?.[0]?.reason === "ALREADY_CANCELED") {
          setShowAlreadyCancelledPst(true);
        }
        // if (showCancelLastTrip) setShowCancelLastTrip(false);
      },
      (error: any) => {
        console.log('Algo ha ido mal', error);
        // if (showCancelLastTrip) setShowCancelLastTrip(false);
        setShowErrorCancelPst(true);
      });
  }


  const renderResumePayment = (data: IData, selectedIndex: number = 0, selectorprice: any, selectordetail: any, showButton: boolean) => {

    const { total, summary } = getPaymentInfoData(data, selectorprice, selectordetail, selectedIndex, fromToData, showButton, t2, t);
    setDataCodePromo({ voucherAmount: summary.discountsNoString })
    setSummary(summary)
    setTripSummary(
      summary
    );

    setTripTotal(total);
  }

  const checkEmptyObject = (obj: object) => {
    return obj
      && Object.keys(obj).length === 0
      && Object.getPrototypeOf(obj) === Object.prototype
  }

  const getCurrentLoggedComponent = (): JSX.Element => {
    let currentComponent: JSX.Element;
    const status = myTripsData?.status;
    currentComponent = !checkEmptyObject(myTripsData) ? checkStatusHttpCall(status) : emptyDiv();

    return currentComponent;
  };

  const checkErrorState = (status: number): JSX.Element => {

    return status === 400 ? failedPage() : getNotLoggedComponent();
  }

  const checkStatusHttpCall = (status: number): JSX.Element => {
    return status === 200 ? _checkIfEmptyResponse() : checkErrorState(status);
  }

  const _checkIfEmptyResponse = () => {
    const reservas = myTripsData?.data?.bookings;
    return (reservas && Array.isArray(reservas) && reservas.length) > 0
      ? detailRoutePage(purchaseType)
      : tripsNotFound()
  }

  const getNotLoggedComponent = (): JSX.Element => {
    return (
      <>
        <div className="error-pages">
          <StartTraveling
            onButtonEventClick={(ev) => handleButtonClick(ev)}
            literals={NoSessionPageLiterals(t)}
          ></StartTraveling>
        </div>
        <LegalFooter literals={footerLiterals}></LegalFooter>
      </>
    );
  };

  const checkInvoiceUrl = () => {
    setShowInvoiceModal(true)
    /* if (cardsInvoiceModal.length !== 0 && cardsInvoiceModal[0].invoiceDownloadUrl !== null) {
       const invoiceUrl = cardsInvoiceModal[0].invoiceDownloadUrl;
       window.location.href = invoiceUrl;
     } else { setShowInvoiceModal(true) }*/
  }

  const detailRoutePage = (type: any): JSX.Element => {
    const showDetailInfo = detailsSelector?.length > 0;
    let typeTrip = type
    if (typeTrip === undefined || typeTrip === '' || typeTrip === null) {
      typeTrip = paginatorData[0]?.purchaseType
    }

    let viewDesktopData
    if (window.innerWidth >= 1281) {
      viewDesktopData = false
    } else {
      viewDesktopData = true

    }

    return (

      <div className="my-past-trips-container" id="my-trips_resumen">
        <div className="row button-mytrips-container">
          <UiIcon icon='back' alt="Imagen de back" class="button-mytrips-container-back col-auto"
            onIconClick={() => handleBack()}>
          </UiIcon>
          <span className="button-mytrips-container-title col-auto " onClick={() => handleBack()}>{generalLiterals.buttontitle}</span>
        </div>
        <div className="row-cols-1">
          <h1 className="my-past-trips-header">{generalLiterals.title}</h1>
        </div>
        <div className="my-past-trips_body">
          <div className="left-section">
            <UiNewPaginator
              onCardPaginatorSelected={(ev: CustomEvent) => handleCardPaginatorSelected(ev)}
              tripPastCardList={paginatorData}
              variant={ItemType.MYPASTTRIPS}
              variantChronology={ItemType.MYPASTTRIPS}
              //itemsPage={4}
              totalPages={totalPages}
              onClickRouteBoxItem={(ev: CustomEvent) => handlePagePaginatorSelected(ev)}
            >

            </UiNewPaginator>
          </div>

          <div className="right-section">
            {typeTrip === travelsType.TRIP ?
              <MDetailRoute
                variant={ItemType.MYPASTTRIPS}
                literals={detailLiterals}
                detailPrice={detailPrice}
                detailLiterals={detailLiteralsAtom}
                detailData={detailsSelector}
                tripSummary={tripSummaryData}
                showBuyButton={false}
                // onSelectedRoute={(ev: CustomEvent) => handleSelectRoute(ev)}
                onTripInfo={(ev: CustomEvent) => handleChangeTripInfo(ev)}
                showDetailInfo={showDetailInfo}
                // onDeleteLeg={handleDeleteItem}
                // onChangeTarif={handleChangeTarif}
                onButtonFooter={(ev) => { manageButtonFooter(ev) }}
                onInvoiceEventEmit={(e) => { checkInvoiceUrl() }}
                onShowOpenModalBolt={() => setShowBoltModal(true)}
                onOpenbreakdownModal={(e) => { setIdLeg(e.detail); setShowSummaryTotal(true) }}
              ></MDetailRoute>
              : null}
            {typeTrip === travelsType.TMB ?
              <MTmbDetailActivity
                literals={detailTMBLiterals}
                detailActivity={detailActivitySelected}
                variant={ItemType.MYPASTTRIPS}
                variantSummary={SummaryType.MYPASTACTIVITIES}
                tabSelected={tab}
                tabs={detailTags(t2)}
                activityType={travelsType.TMB}
                isPastTrip={true}
              ></MTmbDetailActivity>
              : null}
            {typeTrip === travelsType.GLOBICK ?
              <MGlobickDetailActivity
                detailActivity={detailExperienceSelected}
                variant={ItemType.MYPASTTRIPS}
                variantSummary={SummaryType.MYPASTACTIVITIES}
                tabSelected={tab}
                literals={detailTMBLiterals}
                activityType={travelsType.GLOBICK}
                isPastTrip={true}
                viewDesktop={viewDesktopData}
              >

                <div slot="widget">
                  <div id="recoglobick-activities-mmb" />
                </div>
              </MGlobickDetailActivity>
              : null}
            {typeTrip === travelsType.SIXT ?
              <MSixtDetailActivity
                detailActivity={detailSixtSelected}
                literals={sixtDetail(t2)}
                isPastSixt={true}
                variant={ItemType.MYPASTTRIPS}
                variantSummary={SummaryType.MYPASTACTIVITIES}
                activityType={travelsType.SIXT}
                isPastTrip={true}
              >
              </MSixtDetailActivity>
              : null
            }


          </div>

        </div>
        <LegalFooter literals={footerLiterals}></LegalFooter>
      </div>
    );
  };

  const tripsNotFound = (): JSX.Element => {
    return (
      <>
        <div className="error-pages">
          <StartTraveling
            onButtonEventClick={(ev) => handleButtonClick(ev)}
            literals={NoTripsPageLiterals(t)}
          ></StartTraveling>
        </div>
        <LegalFooter literals={footerLiterals}></LegalFooter>
      </>

    );
  };

  const failedPage = (): JSX.Element => {
    return (
      <>
        <div className="error-pages">
          <StartTraveling
            onButtonEventClick={(ev) => handleButtonClick(ev)}
            literals={CallFailedPageLiterals(t)}
          ></StartTraveling>
        </div>
        <LegalFooter literals={footerLiterals}></LegalFooter>
      </>
    );
  };

  const emptyDiv = (): JSX.Element => {
    return (
      <>
        <div></div>
      </>
    );
  };

      /**
      * Vista de "Se ha desconectado algo"
      * @returns TEMPLATE
      */
      const renderNoBuy = () => {
          return (
              <>
                  <StartTraveling literals={DontBuyLiterals(t)} onButtonEventClick={(ev) => handleButtonClick(ev)}></StartTraveling>
              </>
          )
      }


  return (
    <div className="my-past-trips">
      {/* <UiHeaderMyTrips
        literals={{ titlePage: "Mis viajes anteriores" }}
      ></UiHeaderMyTrips> */}
      {/* {logged ? getCurrentLoggedComponent() : getNotLoggedComponent()} */}

      {renderNoBuy()}

      {/* MODALES */}
      <UiModal open={showSummaryTotal}
        onModalClosed={() => setShowSummaryTotal(false)}
      >
        <SummaryAmounts
          literals={desgloseModalLiterals(t)}
          departure={tripTotal?.departure}
          arrival={tripTotal?.arrival}
          onCloseSummaryAmountsEvent={() => setShowSummaryTotal(false)}
          discountData={dataCodePromo}
          total={tripSummaryData?.totalamount}
          idLeg={idLeg}
        ></SummaryAmounts>
      </UiModal>

      <UiModal open={showInvoiceModal}
        blockOverlay={true}
        onModalClosed={() => setShowInvoiceModal(false)}
        nopadding={true}
      >
        <PstInvoices literals={initialInvoiceModalLiterals(t).literals}
          filter={filterTagInvoiceModal}
          detailsSelector={detailsSelector}
          cards={cardsInvoiceModal}
          onCloseInvoiceModal={() => setShowInvoiceModal(false)}
          onSendButtonInvoice={(ev: CustomEvent) => manageButtonRedirecion(ev)}></PstInvoices>
      </UiModal>
      <UiModal open={showTicketsModal} blockOverlay={true} onModalClosed={() => setShowTicketsModal(false)}>
        <CercaniasTickets
          literals={ticketsModalLiterals.literals}
          selector={cercaniasPassengers}
          tickets={tickets}
          onCloseCercaniasModal={() => setShowTicketsModal(false)}
          onCancelTicketButton={() => {
            if (cercaniasPassengers.length === 1) {
              setPSTPassengerToDelete(cercaniasPassengers[0]);
            }
            setShowTicketsModal(false);
            setShowCercaniasTicketCancel(true);
          }}
          onConditionsModal={() => openConditionsLink(t2)}
          onDownloadTicketButton={() => window.print()}>
        </CercaniasTickets>
      </UiModal>
      <UiModal open={showCancelTicketModal} blockOverlay={true}>
        <AccessToApp
          literals={JSON.stringify(getInitialCancelModalLiterals(t))}
          onCancelModal={() => setShowCancelTicketModal(false)}
          onOkModal={() => setShowCancelTicketModal(false)} />
      </UiModal>
      {/* CANCELACIÓN PSTs */}
      {/* [cercanias-renfe] Modal ¿Seguro que quieres cancelar ese billete? */}
      <UiModal open={showCercaniasTicketCancel} blockOverlay={true}>
        <CancelPstAsk
          literals={mytripsliterals.cancelPstAskModal}
          onClickCancelPstButton={(ev: CustomEvent) => handleclickButtonCancelTripModal(ev)}
        ></CancelPstAsk>
      </UiModal>
      <UiModal open={showErrorCancelPst} blockOverlay={true}>
        <CancelPstError
          literals={mytripsliterals.errorCancelation}
          onClickCancelPstErrorButton={(ev: CustomEvent) => setShowErrorCancelPst(false)}
        ></CancelPstError>
      </UiModal>
      <UiModal open={showAlreadyCancelledPst} blockOverlay={true}>
        <CancelPstError
          literals={mytripsliterals.alreadyCancelled}
          onClickCancelPstErrorButton={(ev: CustomEvent) => setShowAlreadyCancelledPst(false)}
        ></CancelPstError>
      </UiModal>
      {/* FIN CANCELACIÓN PSTs */}
      <UiModal open={showAveTicketsModal} blockOverlay={true}>
        <AveTickets
          literals={aveTicketsModalLiterals.literals}
          passengers={avePassengers}
          onOpenTicket={() => downloadAveBlob("billete.pkpass", passBook)}
          onSelectedPassenger={(ev) => handleAveTicketPassenger(ev)}
          onCloseAveTicketsModal={() => setShowAveTicketsModal(false)}></AveTickets>
      </UiModal>
      {/* Modal para la bolsa  postPago*/}
      <UiModal open={showBoltModal} blockOverlay={true}>
        <InfoPostPayment
          literals={checkBoltModalLiterals}
          onCancelModal={() => setShowBoltModal(false)}
          onOkModal={() => setShowBoltModal(false)}
        //supplyCardPrice={supplyCardPrice}

        />
      </UiModal>

      {/* Modal error de facturas*/}
      <UiModal open={showErrorInvocesModal} blockOverlay={true}>
        <AccessToApp
          literals={JSON.stringify(literalesErrorInvocesModal)}
          onCancelModal={() => setShowErrorInvocesModal(false)}
          onOkModal={() => { setShowErrorInvocesModal(false); window.open(t("initialDetailLiterals.disclaimer.url"), '_blank'); }} />
      </UiModal>
    </div>
  );
};

